import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/Dialog';

type Props = {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
};

const NoteDeleteDialog = ({ open, onCancel, onDelete }: Props) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onCancel();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Delete Note</Trans>
          </DialogTitle>
        </DialogHeader>
        <div>
          <Trans>Are you sure you want to delete this note?</Trans>
        </div>
        <DialogFooter>
          <DialogClose
            render={
              <Button size="large">
                <Trans>Cancel</Trans>
              </Button>
            }
          />
          <Button size="large" variant="primary" danger onClick={onDelete}>
            <Trans>Delete</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NoteDeleteDialog;
